import axios from "axios";

export const getAllAllowances = async () => {
    try {
        const response = await axios.get('/allowances/all');
        if (response.data.success) {
            return response.data.data;
        } else {
            console.error('Error fetching allowances:', response.data.message);
        }
    } catch (error) {
        console.error('API Error:', error.message);
    }
};

export const createEmployeeAllowance = async (selectedEmployee, selectedAllowanceType, amount, effectiveDate) => {
    try {
        const response = await axios.post('/crete-allowance', {
            employee: selectedEmployee,
            allowanceType: selectedAllowanceType,
            amount: amount,
            effectiveDate: effectiveDate
        });

        if (response.data.status === 'success') {
            return response.data.data;
        }

        const errorMessage = response.data?.message || 'Failed to create allowance';
        throw new Error(errorMessage);
    } catch (error) {
        const errorMessage = error.response?.data?.message || error.message || 'Failed to create allowance';
        throw new Error(errorMessage);
    }
};

export const getAllEmployeeAllowances = async () => {
    try {
        const response = await axios.get('/all-allowance');
  
        if (response.data.status === 'success') {
            console.log('Employee Allowances:', response.data.data);
            return response.data.data;
        } else {
            console.error('Error:', response.data.message);
        }
    } catch (error) {
        console.error('API Error:', error.message);
    }
};

export const deleteEmployeeAllowance = async (id) => {
    try {
        const response = await axios.delete(`/delete-allowance/${id}`);
        console.log('Allowance deleted:', response.data);
    } catch (error) {
        console.error('Error deleting allowance:', error.response.data);
    }
};

export const getAllowanceById = async (id) => {
    try {
        const response = await axios.get(`/get-allowanceById/${id}`);
        return response.data;
    } catch (error) {
        console.error("Error fetching allowance by ID:", error);
        return null;
    }
};

export const updateEmployeeAllowance = async (selectedAllowance, selectedEmployee, selectedAllowanceType, amount, effectiveDate) => {
    try {
        const response = await axios.put(`/update-allowanceById/${selectedAllowance}`, {
            employee: selectedEmployee,
            allowanceType: selectedAllowanceType,
            amount: amount,
            effectiveDate: effectiveDate
        });
        if (response.data.status === 'success') {
            return response.data.data;
        }

        const errorMessage = response.data?.message || 'Failed to update allowance';
        throw new Error(errorMessage);
    } catch (error) {
        const errorMessage = error.response?.data?.message || error.message || 'Failed to update allowance';
        throw new Error(errorMessage);
    }
};

export const fetchSearchAllowance = async ({name, epf_number, allowanceType, effectiveDate, setLoading}) => {
    try {
        setLoading(true);
        const response = await axios.get(`/search-allowance`, {
            params: {
                name: name,
                epf_number: epf_number,
                allowanceType: allowanceType,
                effectiveDate: effectiveDate
            }, 
            headers: {
                'Cache-Control': 'no-cache'
            }
        });

        setLoading(false);
        console.log(response.data.data, "This is Response");
        return response.data.data.allowances;
    } catch (error) {
        console.error('Error fetching allowances:', error.response ? error.response.data.message : error.message);
        setLoading(false);
        return null;
    }
};

export const getAllowancesByEmployeeId = async (employeeId) => {
    try {
        if (!employeeId) {
            throw new Error("Employee ID is required");
        }

        const response = await axios.get(`/getAllowancesByEmployeeId/${employeeId}`);

        if (response.status === 200) {
            return response.data;
        }
    } catch (error) {
        if (error.response && error.response.status === 404) {
            return []; // No allowances found is a valid case, return empty list
        }
        console.error("Error fetching allowances by employee ID:", error.message);
        throw error;
    }
};